import DefaultMainPage from "../../../pages/DefaultMainPage";
import BadgeManager from "./BadgeManager";
import BadgeTable from "./BadgeTable";

const badgeMasterMenuItems = [
    {path: "/badgeMaster", component: <BadgeManager/>, label: '뱃지 시즌'},
    {path: "/badgeMaster/table", component: <BadgeTable/>, label: '뱃지 마스터'},
];

export const badgeMasterRoutes = {
    path: "/badgeMaster",
    component: <DefaultMainPage buttons={badgeMasterMenuItems}/>,
    children: badgeMasterMenuItems
}